<template>
	<div class="mainRight">
		<publicHotTag/>
		<publicClickRanking :data="data"/>
	</div>
</template>

<script>
	import publicHotTag from '@/components/common/hotTag'
	import publicClickRanking from '@/components/common/clickRanking'
	
	import axios from '@/axios/'
	
	export default{
		components:{
			publicHotTag,publicClickRanking
		},
		data(){
			return{
				data:[],
			}
		},
		async created(){
			try{
				let {data} = await axios('/skill/ranking/list');
				if(data.code==200){
					this.data = data.data;
				}
			}catch(e){
				//
			}
		}
	}
	
</script>

<style scoped>
	.mainRight{
		width: 330px;
		float: right;
	}
</style>
